import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      blue_50: { main: blue50 } = {},
      green_200: { main: green200 } = {},
      green_300: { main: green300 } = {},
      green_500: { main: green500 } = {},
      gray_400: { main: gray400 } = {},
      gray_stroke: { main: grayStroke } = {},
      white_100: { main: white100 } = {},
      yellow_500: { main: yellow500 } = {},
      yellow_100: { main: yellow100 } = {},
      red_50: { main: red50 } = {},
      red_100: { main: red100 } = {},
      dark_50: { main: dark50 } = {},
      dark_400: { main: dark400 } = {},
      dark_stroke: { main: darkStroke } = {}
    } = {}
  } = theme

  return {
    dialogTitle: {
      color: blue300
    },
    inputWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: '8px'
    }
  }
})
